import React from 'react';

import AdministrateRoles from './components/AdministrateRoles';
import Dialogs from './components/Dialogs';
import Invited from './components/Invited';
import ManageOrCreateGroups from './components/ManageOrCreateGroups';
import MembersHeader from './components/MembersHeader';
import Registered from './components/Registered';

import { useOrganizationMembers } from './context';

import { StyledBlock } from './styles';

const OrganizationMembers = () => {
  const {
    hasActiveScimClient,
    manageGroupsOpen,
    userRoles: { administrateUserRoleOpen },
  } = useOrganizationMembers();

  return (
    <StyledBlock>
      {manageGroupsOpen && <ManageOrCreateGroups />}
      {administrateUserRoleOpen && !hasActiveScimClient && (
        <AdministrateRoles />
      )}
      {((!manageGroupsOpen && !administrateUserRoleOpen) ||
        hasActiveScimClient) && (
        <>
          <MembersHeader />
          <Invited />
          <Registered />
        </>
      )}
      <Dialogs />
    </StyledBlock>
  );
};

export default OrganizationMembers;
